import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";
import { useLocation } from "react-router-dom";
import GameBreadcrumb from "../components/GameBreadcrumb.js";
import { QUESTION_ACTION_ENUM } from "../utils/constants.js";
import MarkdownText from "../components/MarkdownText";

const DesignHtml = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");

  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [endPoint, setEndPoint] = useState();
  const [questions, setQuestions] = useState([]);
  // const [level, setLevel] = useState([]);
  // const [role, setRole] = useState([]);
  const [questionId, setQuestionId] = useState();
  const [editForm, setEditForm] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [setId, setSetId] = useState();
  const pathParts = pathname.split("/").filter(Boolean);
  const [isApproved, setIsApproved] = useState(false);
  const location = useLocation();
  const [hash, setHash] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const gameType = pathParts[1];
      // const level = pathParts[2];
      // const role = decodeURIComponent(pathParts[3]).toLowerCase();
      setSetId(pathParts[4]);

      if (!setId || setId === "undefined") return;
      // setLevel(level);
      // setRole(role);

      // Fix: Remove the # symbol from hash
      const question_id = location.hash.substring(1);
      setHash(question_id);
      
      // Scroll to element after a delay
      setTimeout(() => {
        const element = document.getElementById(question_id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);

      // Resolve endpoint
      let endpoint = null;

      if (gameType === "quiz-game") {
        endpoint = "/quiz/";
      } else if (gameType === "one-word-game") {
        endpoint = "/one-word/";
      } else if (gameType === "calculation-game") {
        endpoint = "/calculation/";
      }

      if (!endpoint) return;

      setEndPoint(endpoint);

      try {
        // Final API URL
        // {{quiz_host}}/admin/questions/6938936a-d632-4334-a24c-32612a344566
        const apiUrl = `${endpoint}admin/questions/${setId}`;
        const response = await api.get(apiUrl);
        setQuestions(response.data.data);
        setQuestionId(response.data.question_id);
        setIsApproved(response.data.is_approved);
        console.log("Questions Data:", response.data.is_approved);
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false);
    };

    fetchData();
  }, [pathname, setId, location.hash, loading]);

  const allQuestions = questions.flatMap((action) =>
    action.payload.category_types.flatMap((category) =>
      category.questions.map((question) => ({
        ...question,
        action_no: action.action_no,
      }))
    )
  );

  const updateQuestion = async () => {
    if (!editForm) return;

    const confirmModalEl = document.getElementById("confirmUpdateModal");
    if (confirmModalEl) {
      const confirmInstance =
        window.bootstrap.Modal.getInstance(confirmModalEl);
      confirmInstance?.hide();
    }
    setUpdating(true);

    try {
      const payload = {
        set_id: setId,
        action_no: editForm.action_no,
        question: {
          question_id: editForm.question_id,
          question: editForm.question,
          explanation: editForm.explanation,
          options: editForm.options,
          answer: editForm.answer,
        },
      };

      await api.patch(`${endPoint}admin/update-question`, payload);

      setPopupMessage("Question updated successfully");

      // Update UI without refetch
      setQuestions((prev) =>
        prev.map((action) =>
          action.action_no === editForm.action_no
            ? {
              ...action,
              payload: {
                ...action.payload,
                category_types: action.payload.category_types.map((cat) => ({
                  ...cat,
                  questions: cat.questions.map((q) =>
                    q.question_id === editForm.question_id
                      ? { ...q, ...editForm }
                      : q
                  ),
                })),
              },
            }
            : action
        )
      );
      const modalEl = document.getElementById(
        `editModal-${editForm.question_id}`
      );

      if (modalEl) {
        const modalInstance =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);

        modalInstance.hide();
      }
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to update question");
    } finally {
      setUpdating(false);
    }
  };

  const approveQuestionSet = async () => {
    try {
      setLoading(true);
      const payload = {
        set_id: setId,
        action: QUESTION_ACTION_ENUM.APPROVE,
      };


      let baseUrl = `${endPoint}`;

      baseUrl = `${endPoint}admin/question-action`;

      await api.patch(baseUrl, payload);

      setPopupMessage("Question approved successfully");
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to approved set questions");
    }
    setLoading(false);
  };


  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <GameBreadcrumb quizId={questionId} />
                        <h1 className="mb-2 mt-3">Quiz ID: {questionId}</h1>
                      </div>
                    </div>
                  </div>

                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>{questionId}</h2>
                        </div>
                      </div>
                      <div className="common-right-blk">
                        <div className="common-sort-blk">
                          {/* <button className="secondary_btn py-2 fs-14">Reject</button> */}
                          {!isApproved && (   <button
                            className="secondary_btn py-2 fs-14"
                            onClick={() => approveQuestionSet()}
                          >
                            Approve and Publish
                          </button>)}
                        </div>
                      </div>
                    </div>
                    <div className="common_content_blk">
                      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-xl-2 g-4">
                        {allQuestions.map((question, qIndex) => (
                          <div className="col" key={question.question_id} id={question.question_id}>
                            <div className="quiz_card_wrapper">
                              <div className="vstack gap-3 h-100 justify-content-between">
                                {/* Question */}
                                <div>
                                  <div className="flex-grow-1 mb-4">
                                    <h3 className={`mb-0 fs-5 ${question.question_id === hash ? 'text-danger fw-bold' : ''}`}>
                                      {`Q${qIndex + 1}.`} {question.question}
                                    </h3>
                                  </div>

                                  {/* Options */}
                                  <ol className="question_list" type="A">
                                    {question.options.map((option) => (
                                      <li
                                        key={option.label}
                                        className={`question_item ${question.answer === option.label
                                            ? "correct_answer"
                                            : ""
                                          }`}
                                      >
                                        {option.value}
                                      </li>
                                    ))}
                                  </ol>

                                  <div className="flex-grow-1 mt-4 p-3 bg-light">
                                    <div className="mb-0 fs-6 fw-nornal">
                                      <strong className="me-2">Explanation:</strong>
                                      <MarkdownText>{question.explanation}</MarkdownText>
                                    </div>
                                  </div>
                                </div>

                                {/* Edit Button */}
                                <div className="mt-4">
                                  <button
                                    className="secondary_btn py-2 px-4 w-100 justify-content-center"
                                    data-bs-toggle="modal"
                                    data-bs-target={`#editModal-${question.question_id}`}
                                    onClick={() =>
                                      setEditForm({
                                        question_id: question.question_id,
                                        question: question.question,
                                        options: question.options,
                                        answer: question.answer,
                                        explanation: question.explanation || "",
                                        action_no: question.action_no,
                                      })
                                    }
                                  >
                                    Edit Question
                                  </button>

                                  {/* Edit Modal */}
                                  <div
                                    className="modal fade"
                                    id={`editModal-${question.question_id}`}
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabIndex="-1"
                                  >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">
                                            Edit Question {qIndex + 1}
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                          />
                                        </div>

                                        <div className="modal-body px-4">
                                          {/* Question */}
                                          <div className="form_field">
                                            <label className="fs-14">
                                              Question
                                            </label>
                                            <textarea
                                              className="form-control"
                                              rows="4"
                                              value={editForm?.question || ""}
                                              onChange={(e) =>
                                                setEditForm({
                                                  ...editForm,
                                                  question: e.target.value,
                                                })
                                              }
                                            />
                                          </div>

                                          {/* Answers */}
                                          {editForm?.options.map(
                                            (option, idx) => (
                                              <div
                                                className="form_field"
                                                key={option.label}
                                              >
                                                <label className="fs-14">
                                                  Answer {option.label}.
                                                </label>

                                                <input
                                                  type="text"
                                                  className={`form-control ${editForm.answer ===
                                                      option.label
                                                      ? "correct_answer"
                                                      : ""
                                                    }`}
                                                  value={option.value}
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    setEditForm((prev) => ({
                                                      ...prev,
                                                      options: prev.options.map(
                                                        (opt, i) =>
                                                          i === idx
                                                            ? { ...opt, value }
                                                            : opt
                                                      ),
                                                    }));
                                                  }}
                                                />
                                              </div>
                                            )
                                          )}

                                          {/* Explanation */}
                                          <div className="form_field">
                                            <label className="fs-14">
                                              Explanation
                                            </label>
                                            <textarea
                                              className="form-control"
                                              rows="4"
                                              value={editForm?.explanation || ""}
                                              onChange={(e) =>
                                                setEditForm({
                                                  ...editForm,
                                                  explanation: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="modal-footer border-0 justify-content-center">
                                          <button
                                            className="btn btn-secondary rounded-5 fs-14"
                                            data-bs-dismiss="modal"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            className="secondary_btn py-2 px-4 fs-14"
                                            onClick={() => {
                                              const modal =
                                                new window.bootstrap.Modal(
                                                  document.getElementById(
                                                    "confirmUpdateModal"
                                                  )
                                                );
                                              modal.show();
                                            }}
                                            disabled={updating}
                                          >
                                            {updating
                                              ? "Updating..."
                                              : "Update"}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="confirmUpdateModal"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Update</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    Are you sure you want to update this question?
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary rounded-5 fs-14"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="secondary_btn py-2 px-4 fs-14"
                      onClick={updateQuestion}
                    >
                      Yes, Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default DesignHtml;
